import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import LeftPanel from '../containers/leftpanel/LeftPanelContainer';

const AnalyticsDashboard = React.lazy(() => import('../analytics/AnalyticsDashboard'));

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr);
  height: 100vh;
  height: 100dvh;
  background: #fbf9f5;

  @media (min-width: 992px) {
    grid-template-columns: ${(props) => (props.$collapsed ? '64px' : '256px')} minmax(
        0,
        1fr
      );
    grid-template-rows: minmax(0, 1fr);
  }

  .analytics-navigation,
  main {
    min-width: 0;
    min-height: 0;
  }
  main {
    position: relative;
    height: 100%;
    overflow: auto;
  }
  .analytics-root {
    min-height: 100%;
  }
  .analytics-status {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #fbf9f5;
    color: #59616a;
  }
`;

export default function AnalyticsPage() {
  const { t } = useTranslation();
  const { leftpanel, user, checking } = useSelector((state) => ({
    leftpanel: state.leftpanel,
    user: state.user.user,
    checking: state.loading['user/CHECK'],
  }));
  const accountKey = user ? `${user.data_loc || ''}:${user.id}` : '';
  const sidebarCollapsed = leftpanel.collapsed || leftpanel.collapsedAuto;
  const loading = (
    <div role="status" className="analytics-status">
      {t('Connecting your analytics…')}
    </div>
  );

  return (
    <Layout $collapsed={sidebarCollapsed}>
      <div className="analytics-navigation">
        <LeftPanel />
      </div>
      <main>
        {user && !checking ? (
          <Suspense fallback={loading}>
            <AnalyticsDashboard
              key={`${accountKey}:${user.email || ''}`}
              accountKey={accountKey}
            />
          </Suspense>
        ) : (
          loading
        )}
      </main>
    </Layout>
  );
}
